import { Component, inject } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { ServicesCardComponent } from '@components/cards/services-card/services-card.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ln-services',
  imports: [LnPagesArmorComponent, TranslocoPipe, ServicesCardComponent],
  templateUrl: './services.component.html',
  styleUrl: './services.component.css',
})
export class ServicesComponent {
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;
  protected imagePathServicesDesign: string =
    environment.GOOGLE_STORAGE_URL + '/imagenes/' + environment.banners.SERVICES_DESIGN;
  protected imagePathServicesManagement: string =
    environment.GOOGLE_STORAGE_URL + '/imagenes/' + environment.banners.SERVICES_MANAGEMENT;
}
